import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Download, Printer, FileText } from "lucide-react";

const FICHAS = [
  { key: "rectangulo", nombre: "Modelo Rectángulo", desc: "Ficha técnica con medidas (cm) de todas las variantes rectangulares.", url: "/fichas/rectangulo.pdf" },
  { key: "cuadrado", nombre: "Modelo Cuadrado", desc: "Ficha técnica con medidas (cm) de todas las variantes cuadradas.", url: "/fichas/cuadrado.pdf" },
  { key: "mixto", nombre: "Modelo Mixto", desc: "Ficha técnica con medidas (cm) de todas las variantes mixtas.", url: "/fichas/mixto.pdf" },
  { key: "duelamax", nombre: "DuelaMAX", desc: "Ficha técnica con medidas (cm) de la línea DuelaMAX.", url: "/fichas/duelamax.pdf" },
];

export default function FichasTecnicas() {
  const navigate = useNavigate();

  const descargar = (url, nombre) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = `Ficha tecnica - ${nombre}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const imprimir = (url) => {
    const ifr = document.createElement("iframe");
    ifr.style.display = "none";
    ifr.src = url;
    ifr.onload = () => {
      try { ifr.contentWindow.focus(); ifr.contentWindow.print(); }
      catch (e) { window.open(url, "_blank"); }
    };
    document.body.appendChild(ifr);
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="fichas-tecnicas-page">
      <Button variant="ghost" size="sm" onClick={() => navigate("/configuracion")}><ArrowLeft className="h-4 w-4 mr-2" /> Configuración</Button>
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Fichas Técnicas</h1>
        <p className="text-muted-foreground mt-2">Descarga o imprime las fichas técnicas oficiales de cada modelo de duela.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {FICHAS.map((f) => (
          <Card key={f.key} data-testid={`ficha-${f.key}`}>
            <CardHeader className="flex flex-row items-center gap-3 pb-2">
              <div className="p-2 bg-primary/10 rounded-lg"><FileText className="h-6 w-6 text-primary" /></div>
              <CardTitle className="text-lg">{f.nombre}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground">{f.desc}</p>
              <div className="flex flex-wrap gap-2">
                <Button variant="outline" size="sm" onClick={() => descargar(f.url, f.nombre)} data-testid={`ficha-descargar-${f.key}`}><Download className="h-4 w-4 mr-2" /> Descargar</Button>
                <Button variant="outline" size="sm" onClick={() => imprimir(f.url)} data-testid={`ficha-imprimir-${f.key}`}><Printer className="h-4 w-4 mr-2" /> Imprimir</Button>
                <Button variant="ghost" size="sm" onClick={() => window.open(f.url, "_blank")} data-testid={`ficha-ver-${f.key}`}>Ver</Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
